export default "__VITE_ASSET__CgXuBes0__"